import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M1.75 5.00001C1.75 3.75736 2.75736 2.75 4 2.75H20C21.2426 2.75 22.25 3.75735 22.25 4.99999L22.25 6.99999C22.25 7.78009 21.853 8.46746 21.25 8.8711V19.5C21.25 20.4665 20.4665 21.25 19.5 21.25H4.50003C3.53353 21.25 2.75003 20.4665 2.75003 19.5V8.87113C2.14703 8.4675 1.75001 7.78012 1.75001 7.00001L1.75 5.00001ZM4.25003 9.25H19.75V19.5C19.75 19.6381 19.6381 19.75 19.5 19.75H4.50003C4.36196 19.75 4.25003 19.6381 4.25003 19.5V9.25ZM4 4.25C3.58579 4.25 3.25 4.58579 3.25 5L3.25001 7C3.25001 7.41422 3.58579 7.75 4.00001 7.75H20C20.4142 7.75 20.75 7.41421 20.75 7L20.75 5C20.75 4.58578 20.4142 4.25 20 4.25H4ZM7.49998 11.75C7.08577 11.75 6.74998 12.0858 6.74998 12.5C6.74998 12.9142 7.08577 13.25 7.49998 13.25H16.5C16.9142 13.25 17.25 12.9142 17.25 12.5C17.25 12.0858 16.9142 11.75 16.5 11.75H7.49998Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
